import { endpoints, baseurl } from "../Utils/Constants";

export const getEmailTemplates = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.EMAIL_TEMPLATES, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching email templates:', error);
        throw error;
    }
};

export const deleteEmailTemplate = async (id, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_EMAIL_TEMPLATE + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting email template:', error);
        throw error;
    }
};

export const getEmailTemplateById = async (id, acc_id, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_EMAIL_TEMPLATE_BY_ID + id + `/${acc_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching email template by ID:', error);
        throw error;
    }
};

export const saveEmailTemplate = async (templateData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_EMAIL_TEMPLATE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(templateData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving email template:', error);
        throw error;
    }
};

export const getAllContentTypes = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_CONTENT_TYPES, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching content types:', error);
        throw error;
    }
};